// extracted by mini-css-extract-plugin
export default {"fullWidth":"_5lpQ2"};